import React from 'react'

export const RewardsIcon = ({ color = 'currentColor' }) => {
  return (
    <svg width="28" height="28" x="0px" y="0px" viewBox="0 0 26.7 24" color={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 25C5.6 25 0 19.4 0 12.5S5.6 0 12.5 0s12.5 5.6 12.5 12.5-5.6 12.5-12.5 12.5ZM12.5 22.5c2.65 0 5.2-1.05 7.07-2.93 1.88-1.88 2.93-4.42 2.93-7.07s-1.05-5.2-2.93-7.07c-1.88-1.88-4.42-2.93-7.07-2.93s-5.2 1.05-7.07 2.93c-1.88 1.88-2.93 4.42-2.93 7.07s1.05 5.2 2.93 7.07c1.88 1.88 4.42 2.93 7.07 2.93ZM12.5 18.95c-4.51 0-5.14-2.52-5.14-4.93 0-2.1 3.15-7.97 5.14-7.97s5.14 5.77 5.14 7.97c0 2.41-.63 4.93-5.14 4.93ZM12.5 8.25c-.94.94-3.04 4.19-3.04 5.66 0 1.89.1 2.83 3.04 2.83s3.04-1.05 3.04-2.83c0-1.36-2.1-4.72-3.04-5.66Z" fill={color} />
    </svg>
  )
}
